import { render, staticRenderFns } from "./maling-set.vue?vue&type=template&id=12e315e5&scoped=true&"
import script from "./maling-set.vue?vue&type=script&lang=js&"
export * from "./maling-set.vue?vue&type=script&lang=js&"
import style0 from "./maling-set.vue?vue&type=style&index=0&id=12e315e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e315e5",
  null
  
)

export default component.exports